import React, { useEffect, useState } from "react";
import * as APIS from "../../../service/apis/blogs.apis";
import { useDispatch } from "react-redux";
import { SingleBlog } from "redux/actions/productAction";
import { history } from "redux/store/store";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import moment from "moment";
import { BsArrowUpRight } from "react-icons/bs";
import 'swiper/swiper-bundle.css'


function RecentBlog() {

    const [blogs, setBlogs] = useState([]);
    const [pageInfo, setPageInfo] = useState({});
    const dispatch = useDispatch();

    async function temp() {
        let productInfo = await APIS.GetBlogs();
        setBlogs(productInfo.articles.edges);
        setPageInfo(productInfo.articles.pageInfo);
    }

    useEffect(() => {
        temp();
    }, []);

    const swiperOptionsBlog = {
        initialSlide: 0,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        autoHeight: true,
    }

    const extractDateFromTags = (tags, fallbackDate) => {
        const dateTag = tags.find(tag => tag.startsWith("date-"));
        if (!dateTag) {
            // Fallback to the publishedAt date if no date tag exists
            return moment(fallbackDate).format("DD MMM YYYY");
        }
        const parts = dateTag.split('-')[1]; // Extract "5_Nov_2024"
        const [day, month, year] = parts.split('_');
        return `${day} ${month} ${year}`; // Format as "5 Nov 2024"
    };
    

    if (blogs.length === 0) return (false);

    return (
        <>
            <div className="blogtitles py-3 pb-5">
                <h4 className="text-center mb-0 main--title">Recent Blogs</h4>
                <div className="moreBlogs">
                    <Link to='/blogs'>view all</Link>
                </div>
            </div>
            
            <div className="row rowBlog">

                <div className="col-12 col-lg-6">
                    <div className="blogCard">
                        <div className="mainImage">
                            <img src={blogs[0].node.image.url} alt="" />
                        </div>
                        <div className="blogContent ">
                            <div>
                                <p className="calendarDate"><span></span> {extractDateFromTags(blogs[0].node.tags,blogs[0].node.publishedAt)}</p>
                                <h3><Link to={`/blog/${blogs[0].node.handle}`}>{blogs[0].node.title}</Link>  </h3>
                            </div>
                            <small className="content-small">{blogs[0]?.node.content || ""}</small>
                        </div>
                        <div className="readMain ">
                            <button
                                className="readMoreBtn"
                                onClick={() => {
                                    dispatch(SingleBlog(blogs[0]));
                                    history.push(`/blog/${blogs[0].node.handle}`);
                                }}
                            >
                                Read More <BsArrowUpRight />
                            </button>
                        </div>
                    </div>
                </div>

                <div className="col-12 col-lg-6">
                    <div className="secondaryBlogs">
                        {blogs.slice(1, 4).map((blog, i) => {
                            return <div className="blogCardsec">
                                <div className="blogContent">
                                    <div>
                                        <p className="calendarDate"><span> </span> {extractDateFromTags(blogs[i+1].node.tags,blogs[i+1].node.publishedAt)}</p>
                                        <h3><Link to={`/blog/${blog.node.handle}`}>{blog.node.title}</Link>  </h3>
                                    </div>
                                    <small className="content-small">{blog?.node.content || ""}</small>
                                </div>
                                <div className="readMain ">
                                    <button
                                        className="readMoreBtn"
                                        onClick={() => {
                                            dispatch(SingleBlog(blog));
                                            const titleSlug = blog.node.title.replace(/\s+/g, '-').toLowerCase();
                                            history.push(`/blog/${titleSlug}`);
                                        }}
                                    >
                                        Read More <BsArrowUpRight />
                                    </button>
                                </div>
                            </div>
                        })}
                    </div>
                </div >
            </div >
        </>
    )
}

export default RecentBlog;